export default __webpack_public_path__ + "static/media/pan.12b166f6.png";